import { Box } from '@mui/material';
import { parseHtml } from 'ckeditor5';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { GetAllBlog } from '../../services/ApiServices/BlogService';
import '../../styles/blog.css';

function Blog({setLoading}: any) {
    const [blogs, setBlogs] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');


    const fetchBlogs = async () => {
        let userInfos = null;
        setLoading(true);
        try {
            userInfos = await GetAllBlog();
            setLoading(false);
            setBlogs(userInfos);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            setLoading(false);
            return;
        }
    }

    useEffect(() => {
        fetchBlogs();
        const elements = document.querySelectorAll('oembed');
        console.log(elements);
        
        elements.forEach(element => {
                const url = element.getAttribute('url');
                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', url??"");
                iframe.setAttribute('width', '100%');
                iframe.setAttribute('height', '400px');
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                iframe.setAttribute('allowfullscreen', "true");
                element.parentNode?.replaceChild(iframe, element);
        });
    }, []);

    return (
      <div className="blogs-wrapper">
       {blogs.map((blog: any) => (
        <Box className="blog-inside-wrapper mt-5 mb-5 p-0" sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3, maxWidth: 800, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
            <img style={{width: "100%"}} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8Dyq1gtNFnF2O9ue7Ol5Ku5kSWigqguiVlA&s"/>
            <div style={{ fontSize: "20px" }} className="about-header text-center font-bold">
                <h1>{blog.title}</h1>
                <div className="underline"></div>
            </div>
            <div className="card-wrapper mt-2">
                <p>{parse(blog.content)}</p>
            </div>
            <p className="font-bold text-lg">...</p>
        </Box>
        ))}
       </div>
    );
}

export default Blog;
